import React from 'react';
import CustomModal from './CustomModal';
import {DangerButton} from './CustomButton';

const ConfirmModal = ({
                        children,
                        setShowModal,
                        showModal,
                        disabled,
                        onConfirm,
                        title = 'Attention',
                        buttonLabel = 'Remove'
                      }) => {
  return (
    <CustomModal
      showModal={showModal}
      setShowModal={setShowModal}
      title={title}
      bodyClasses="max-w-md"
      loading={disabled}
      button={
        !!onConfirm && (
          <DangerButton onClick={onConfirm} disabled={disabled}>
            {buttonLabel}
          </DangerButton>
        )
      }
    >
      <div className="py-7">{children}</div>
    </CustomModal>
  );
};

export default React.memo(ConfirmModal);


